import { render, staticRenderFns } from "./EmailItem.vue?vue&type=template&id=3a61d208&"
import script from "./EmailItem.vue?vue&type=script&lang=ts&"
export * from "./EmailItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports